import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateTagComponent } from './update-tag/update-tag.component';
import { AddTagComponent } from './add-tag/add-tag.component';
import { TagListComponent } from './tag-list/tag-list.component';
import { TagRoutingModule } from './tag.routing';
import { ToastrModule } from 'ngx-toastr';
import {NgxPaginationModule} from 'ngx-pagination';
import { FormsModule } from '@angular/forms';
import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';

@NgModule({
  declarations: [
    AddTagComponent,
    UpdateTagComponent,
    TagListComponent
  ],
  imports: [
    CommonModule,
    TagRoutingModule,
    NgxPaginationModule,
    FormsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    ModalModule.forRoot(),
  ]
})
export class TagModule { }
